import { InjectionToken, Signal, WritableSignal } from '@angular/core';
import { ServiceTypeEnum } from '@libs/types/src/services/enum/service-type.enum';
import { Rules } from './acl.types';
import { SettingsGqlService } from '../../services/settings.gql-service';
import { AuthenticatedUserObject, NotificationObject } from '@it2go/types';
import { EmploymentGridItemObject } from '@libs/types/src/user/object-type/employment-grid.object';
import { ExportImportProgressObject } from '@libs/types/src/export-import/object-type/export-import.progress-object';
import { TableSetting } from '../logged-user.global-store';
import { GroupUserObject } from '@libs/types/src/user/object-type/group-user.object';

export const LOGGED_USER_GLOBAL_STORE_TOKEN = new InjectionToken<LoggedUserGlobalStoreType>('LoggerUserGlobalStoreType');

export interface LoggedUserGlobalStoreType {

    settingsService: SettingsGqlService;
    currentUser: Signal<AuthenticatedUserObject | null>;
    currentUserId: Signal<string | null>;
    employments: Signal<EmploymentGridItemObject[]>;
    groupMemberships: Signal<GroupUserObject[]>;
    rules: Signal<Rules>;
    customColors: Signal<string[]>;
    selectedServiceId: Signal<number | null>;
    selectedServiceTypeContext: Signal<ServiceTypeEnum>;
    showCheckoutPlans: Signal<boolean>;
    newNotification: Signal<NotificationObject | null | undefined>;
    exportImportProgress: Signal<ExportImportProgressObject | null | undefined>;
    tableSettings: Signal<WritableSignal<Record<string, TableSetting>>>;

    setSelectedServiceId(id?: number | string | null): Promise<void>;
    setServiceTypeContext(type?: ServiceTypeEnum): Promise<void>;
    setShowCheckoutPlans(value: boolean): Promise<void>;
    getEmploymentsByServiceId(id: Signal<number>): Signal<EmploymentGridItemObject | undefined>;
    clearAcl(): void;

}
